// import { useI18n } from 'vue-i18n'
// console.log(useI18n,'useI18n')

// const { t } = useI18n()
// import i18n from '@/locales/index'
const title = '业务管理系统'

export default function getPageTitle(pageTitle?: any) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
